import { PaymentChannelModel } from 'api-hooks/payment-channel';
import React from 'react';

import { PaymentChannelFormType } from '../components/form-type';

export default function usePaymentChannelDefaultValues(
  paymentChannel?: PaymentChannelModel,
): PaymentChannelFormType {
  const defaultValues = React.useMemo<PaymentChannelFormType>(() => {
    return {
      description: paymentChannel?.description || '',
      isActive: paymentChannel?.isActive ?? false,
      name: paymentChannel?.name || '',
      paymentChannel,
    };
  }, [paymentChannel]);
  return defaultValues;
}
